import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Dropdown, Space } from 'antd';
import { useEffect, useState } from 'react';
import { getBackendVersion, getUIVersion } from '@/utils/version';

type DropdownProp = {
	currentUser: API.CurrentUser;
	onLogout: () => void;
};

const InfoDropdown: React.FC<DropdownProp> = ({ currentUser, onLogout }) => {
	const [backendVersion, setBackendVersion] = useState<string>('Loading...');
	const uiVersion = getUIVersion();

	useEffect(() => {
		// Fetch backend version on mount
		getBackendVersion().then(setBackendVersion);
	}, []);

	return (
		<Dropdown
			menu={{
				items: [
					{
						key: 'version-info',
						label: (
							<div style={{ padding: '4px 0' }}>
								<div style={{ fontSize: '12px', color: '#8c8c8c' }}>
									<strong>UI Version:</strong> {uiVersion}
								</div>
								<div
									style={{
										fontSize: '12px',
										color: '#8c8c8c',
										marginTop: '4px',
									}}
								>
									<strong>Backend:</strong> {backendVersion}
								</div>
							</div>
						),
						disabled: true,
						style: { cursor: 'default' },
					},
					{
						type: 'divider',
					},
					{
						key: 'logout',
						icon: <LogoutOutlined />,
						label: 'Logout',
						onClick: onLogout,
					},
				],
			}}
		>
			<Space style={{ cursor: 'pointer' }}>
				<img
					src="/speedcargo-icon.png"
					alt="logo"
					style={{
						height: 38,
						marginRight: 3,
						display: 'block',
						marginTop: 2,
					}}
				/>
				<Avatar size="small" src={currentUser.avatar} icon={<UserOutlined />} />
				<span>{currentUser.name}</span>
			</Space>
		</Dropdown>
	);
};

export default InfoDropdown;
